import axios from "axios";
import routes from "../app/routes";

export const countryActions = {
  load: (dispatch) => {
    axios.get(routes.api.countries.index).then((resp) => {
      dispatch({ type: "load", countries: resp.data.data });
    });
  },
};
